/**
 * affiliate-shared.tsx — Thành phần dùng chung cho các trang Platform → Tiếp thị liên kết.
 */
import { useState, type ReactNode } from 'react'
import dayjs from 'dayjs'
import { Loader2 } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Label } from '@/components/ui/label'
import { Textarea } from '@/components/ui/misc'
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog'

export const fmtDate = (iso: string | null | undefined) => (iso ? dayjs(iso).format('DD/MM/YYYY') : '—')
export const fmtDateTime = (iso: string | null | undefined) => (iso ? dayjs(iso).format('DD/MM/YYYY HH:mm') : '—')

/** Hộp nhập lý do (bắt buộc) trước thao tác nhạy cảm — lý do được ghi vào nhật ký Platform. */
export function ReasonDialog({
  open, title, description, confirmLabel = 'Xác nhận', destructive, pending, children, onClose, onConfirm,
}: {
  open: boolean
  title: string
  description?: string
  confirmLabel?: string
  destructive?: boolean
  pending?: boolean
  children?: ReactNode
  onClose: () => void
  onConfirm: (reason: string) => void
}) {
  const [reason, setReason] = useState('')
  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) { setReason(''); onClose() } }}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          {description && <DialogDescription>{description}</DialogDescription>}
        </DialogHeader>
        {children}
        <div className="space-y-1.5">
          <Label htmlFor="aff-reason">Lý do (ghi vào nhật ký)</Label>
          <Textarea id="aff-reason" rows={3} value={reason} onChange={(e) => setReason(e.target.value)} maxLength={500} />
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => { setReason(''); onClose() }}>Huỷ</Button>
          <Button
            variant={destructive ? 'destructive' : 'default'}
            disabled={reason.trim().length < 3 || pending}
            onClick={() => { onConfirm(reason.trim()); setReason('') }}
          >
            {pending && <Loader2 className="h-4 w-4 animate-spin" />} {confirmLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

/** Nút lọc dạng chip. */
export function FilterChips({ value, options, onChange }: { value: string; options: [string, string][]; onChange: (v: string) => void }) {
  return (
    <div className="flex flex-wrap gap-1">
      {options.map(([v, l]) => (
        <Button key={v || 'all'} size="sm" variant={value === v ? 'default' : 'outline'} onClick={() => onChange(v)}>{l}</Button>
      ))}
    </div>
  )
}
